<template>
  <HeaderLayout/>
  <GlobalNavBar/>
  <div id="container">
    <div id="contents" class="aidtp3-contents">
      <BreadcrumbLayout pageId="monTASK_taskAIDTP3" :name="'[TASK] AI DT P3'"/>
      <div class="iframe-wrap">
        <iframe
          :src="iframeSrc"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
  <FooterLayout/>
</template>

<script>
import Cookies from "js-cookie";
import HeaderLayout from "@/components/HeaderLayout.vue";
import GlobalNavBar from "@/components/GlobalNavBar.vue";
import FooterLayout from "@/components/FooterLayout.vue";
import BreadcrumbLayout from "@/components/BreadcrumbLayout.vue";
import common from "@/assets/js/common";

export default {
  name: "AIDTP3",
  components: {
    HeaderLayout,
    GlobalNavBar,
    FooterLayout,
    BreadcrumbLayout,
  },
  data() {
    return {
      prjId: null,
      taskId: null,
      viewRole: false,
      iframeSrc: "",
    };
  },
  async mounted() {
    this.prjId = this.$route.query.prjId;
    this.taskId = this.$route.query.taskId;
    await this.setRole();
    // last_visit 갱신을 위해 task 데이터 조회
    await this.getTaskData(this.taskId);
    // iframe src에 JWT 토큰 포함
    this.buildIframeSrc();
  },
  methods:{
    buildIframeSrc() {
      const token = Cookies.get("jwt");
      if (token) {
        this.iframeSrc = `http://172.20.102.115:13000/?token=${encodeURIComponent(token)}`;
      } else {
        this.iframeSrc = "http://172.20.102.115:13000/";
      }
    },
    async getTaskData(taskId) {
      try {
        const _taskId = encodeURIComponent(taskId);
        await common.apiGet(`/monitoring-task/${_taskId}?viewRole=${this.viewRole}`);
      } catch (error) {
        console.error("Error fetching task data:", error);
      }
    },
    async setRole() {
      const prjId = this.$route.query.prjId;
      this.viewRole = (await common.getUserRole("type2") || await common.getPrjRole("type1", prjId));
    },
  },
};
</script>

<style scoped>
.aidtp3-contents {
  padding: 10px 10px 0 !important;
}
.iframe-wrap {
  width: 100%;
  height: calc(100vh - 100px);
}
.iframe-wrap iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
